import { render, staticRenderFns } from "./PassengerList.vue?vue&type=template&id=0e382011&scoped=true"
import script from "./PassengerList.vue?vue&type=script&lang=js"
export * from "./PassengerList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e382011",
  null
  
)

export default component.exports